module.exports = __webpack_public_path__ + "static/media/kuaraHorizontalSmall.d67c8498.svg";